import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';

import { TasksRoutingModule } from './tasks-routing.module';
import { TaskContainerComponent } from './task/task.container';
import { TaskComponent } from './task/task.component';

@NgModule({
    declarations: [
        TaskContainerComponent,
        TaskComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        TasksRoutingModule
    ]
})
export class TasksModule { }
